import React, {ReactElement} from 'react';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';
import {ELEMENT} from '../../../../incase-domain/elements/base/ElementTypes';
import {HtmlSlottedElement} from '../../../../incase-domain/elements/html/htmlSlot';
import {
    LikertScaleInteractions,
    ElementInteraction,
    QuestionElementInteractions,
    SequenceQuestionInteraction,
} from '../../../../incase-domain/proptypes/runfile';
import {MultiselectQuestionElement} from '../question/multiSelect/MultiselectQuestionElement';
import SequenceQuestionElement from '../question/sequence/SequenceQuestionElement';
import LikertScaleQuestionElement from '../question/likertScale/LikertScaleQuestionElement';
import QuestionElement from '../question/question/QuestionElement';

interface HtmlSlottedElementPortalProps {
    element: HtmlSlottedElement;
    device?: DeviceType;
    elementInteractions: ElementInteraction;
    savePresentationRunFile: (elementRunFile: ElementInteraction, newPoints?: number) => void;
}

function HtmlSlottedElementPortal({
    element,
    device,
    elementInteractions,
    savePresentationRunFile,
}: HtmlSlottedElementPortalProps): ReactElement | null {
    switch (element.type) {
        case ELEMENT.QUESTION:
            return (
                <QuestionElement
                    element={element}
                    device={device}
                    elementInteractions={elementInteractions as QuestionElementInteractions}
                    savePresentationRunFile={savePresentationRunFile}
                />
            );
        case ELEMENT.MULTI_SELECT:
            return (
                <MultiselectQuestionElement
                    element={element}
                    device={device}
                    elementInteractions={elementInteractions as QuestionElementInteractions}
                    savePresentationRunFile={savePresentationRunFile}
                />
            );
        case ELEMENT.SEQUENCE_QUESTION:
            return (
                <SequenceQuestionElement
                    element={element}
                    device={device}
                    elementInteractions={elementInteractions as SequenceQuestionInteraction}
                    savePresentationRunFile={savePresentationRunFile}
                />
            );
        case ELEMENT.LIKERT_SCALE:
            return (
                <LikertScaleQuestionElement
                    element={element}
                    device={device}
                    elementInteractions={elementInteractions as LikertScaleInteractions}
                    savePresentationRunFile={savePresentationRunFile}
                />
            );
        default:
            return null;
    }
}

export default HtmlSlottedElementPortal;
